import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./TabBarItem.scss";

export const TabBarItem = ({ children, label, activeTab, hiddenByDefault, ...attrs }) => {
    if(hiddenByDefault && activeTab !== label){
        return null;
    }

    return (
        <div
            className={classNames("tab-bar-item", { active: activeTab === label })}
            {...attrs}
        >
            {children}
        </div>
    );
};

TabBarItem.propTypes = {
    label: PropTypes.string.isRequired,
    children: PropTypes.node,
    activeTab: PropTypes.string
};

TabBarItem.defaultProps = {
    children: null,
    activeTab: ""
};
